import React, { useState, useCallback } from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aureate-preview/artifacts/h6n4fhlc_Only%20Logo.png';

const NAV_LINKS = [
  { label: 'Approach', href: '#approach' },
  { label: 'Organisations', href: '#organisations' },
  { label: 'Property owners', href: '#owners' },
  { label: 'About', href: '#founder' },
  { label: 'Contact', href: '#contact' },
];

const MOBILE_LINKS = [
  { label: 'Approach', href: '#approach' },
  { label: 'For organisations', href: '#organisations' },
  { label: 'For property owners', href: '#owners' },
  { label: 'About', href: '#founder' },
  { label: 'Contact', href: '#contact' },
];

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = useCallback((href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  }, []);

  const handleLink = useCallback((e, href) => {
    e.preventDefault();
    scrollTo(href);
  }, [scrollTo]);

  return (
    <header className="site-header" data-testid="main-navigation">
      <div className="wrap">
        <div className="bar">
          {/* Brand / Logo */}
          <a
            className="brand"
            href="#top"
            aria-label="Aureate Residences home"
            onClick={(e) => handleLink(e, '#top')}
            data-testid="nav-logo"
          >
            <img src={LOGO_URL} alt="" />
            <span className="bt">
              <b>AUREATE</b>
              <span className="rule" />
              <small>RESIDENCES</small>
            </span>
          </a>

          {/* Desktop nav links */}
          <nav className="links" aria-label="Main">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleLink(e, link.href)}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <a
            className="btn btn-gold"
            href="#contact"
            onClick={(e) => handleLink(e, '#contact')}
            data-testid="nav-cta-button"
          >
            Discuss a requirement
          </a>

          {/* Mobile menu toggle */}
          <div className={`menu${menuOpen ? ' menu-open' : ''}`}>
            <button
              className="menu-btn"
              aria-label="Menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              data-testid="mobile-menu-toggle"
            >
              <span /><span /><span />
            </button>

            {/* Mobile panel */}
            <nav className="panel" aria-label="Main">
              {MOBILE_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleLink(e, link.href)}
                  data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </a>
              ))}
              <a
                className="btn btn-gold"
                href="#contact"
                onClick={(e) => handleLink(e, '#contact')}
                data-testid="mobile-cta-button"
              >
                Discuss a requirement
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navigation;
